import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaDiscord } from 'react-icons/fa';
import Navbar from '../../components/Navbar/Navbar';
import { useI18n } from '../../i18n';
import './TermosDeServico.css';

function RichText({ text }) {
  if (!text) return null;
  const parts = String(text).split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}

function BlockContent({ block }) {
  if (!block) return null;

  if (block.type === 'p') {
    return (
      <p>
        <RichText text={block.text} />
      </p>
    );
  }

  if (block.type === 'ul' && Array.isArray(block.items)) {
    return (
      <ul>
        {block.items.map((item, i) => (
          <li key={i}>
            <RichText text={item} />
          </li>
        ))}
      </ul>
    );
  }

  if (block.type === 'h') {
    return (
      <p>
        <strong>
          <RichText text={block.text} />
        </strong>
      </p>
    );
  }

  if (block.type === 'note') {
    return (
      <p className="termos-note">
        <RichText text={block.text} />
      </p>
    );
  }

  return null;
}

const TermosDeServico = () => {
  const { get, t } = useI18n();
  const sections = get('terms.sections') || [];

  useEffect(() => {
    if (window.location.hash !== '#doacoes') return;

    const element = document.getElementById('doacoes');
    if (!element) return;

    const headerOffset = 100;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }, []);

  return (
    <div className="termos">
      <Navbar />

      <section className="termos-hero">
        <div className="termos-hero__glow" aria-hidden="true" />
        <div className="termos-hero__blocks" aria-hidden="true" />
        <div className="termos-wrap termos-hero__content">
          <p className="termos-hero__kicker">{t('terms.kicker')}</p>
          <h1 className="termos-hero__title">{t('terms.title')}</h1>
          <p className="termos-hero__lead">{t('terms.lead')}</p>
          <p className="termos-hero__meta">{t('terms.updated')}</p>
        </div>
      </section>

      <section className="termos-body">
        <div className="termos-wrap termos-layout">
          <nav className="termos-toc" aria-label={t('terms.tocAria')}>
            <p className="termos-toc__label">{t('terms.tocLabel')}</p>
            <ol>
              {sections.map((section) => (
                <li key={section.id}>
                  <a href={`#${section.id}`}>
                    <span>{section.number}</span>
                    {section.title}
                  </a>
                </li>
              ))}
            </ol>
          </nav>

          <div className="termos-doc">
            {sections.map((section) => (
              <article
                key={section.id}
                id={section.id}
                className="termos-block"
                style={{ scrollMarginTop: '100px' }}
              >
                <header className="termos-block__head">
                  <span className="termos-block__num">{section.number}</span>
                  <h2>{section.title}</h2>
                </header>
                <div className="termos-block__body">
                  {(section.blocks || []).map((block, i) => (
                    <BlockContent key={`${section.id}-${i}`} block={block} />
                  ))}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="termos-cta">
        <div className="termos-wrap termos-cta__inner">
          <h2>{t('terms.ctaTitle')}</h2>
          <p>{t('terms.ctaLead')}</p>
          <div className="termos-cta__actions">
            <a
              href="https://discord.gg/9W4Vusc4m2"
              target="_blank"
              rel="noopener noreferrer"
              className="termos-btn termos-btn--primary"
            >
              <FaDiscord />
              {t('terms.ctaDiscord')}
            </a>
            <Link to="/" className="termos-btn termos-btn--ghost">
              {t('terms.backHome')}
            </Link>
          </div>
        </div>
      </section>

      <footer className="termos-footer">
        <div className="termos-wrap termos-footer__top">
          <div className="termos-footer__brand">
            <p className="termos-footer__name">{t('common.brand')}</p>
            <p>{t('terms.footerBrand')}</p>
          </div>
          <div className="termos-footer__cols">
            <div>
              <h4>{t('common.links')}</h4>
              <ul>
                <li><a href="/">{t('nav.home')}</a></li>
                <li><a href="/vip">{t('nav.vip')}</a></li>
                <li><a href="/conta">{t('nav.myAccount')}</a></li>
                <li><a href="/termos">{t('common.terms')}</a></li>
                <li><a href="/termos#privacidade">{t('terms.privacyLink')}</a></li>
              </ul>
            </div>
            <div>
              <h4>{t('common.community')}</h4>
              <ul>
                <li>
                  <a href="https://discord.gg/9W4Vusc4m2" target="_blank" rel="noopener noreferrer">
                    {t('common.discord')}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="termos-footer__bottom">
          <p>{t('common.copyright')}</p>
        </div>
      </footer>
    </div>
  );
};

export default TermosDeServico;
